var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen bg-gray-100"},[_c('navbar'),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"max-w-7xl mx-auto sm:px-6 lg:px-8"},[_vm._v("\n            // CONTENT\n        ")])])
}]

export { render, staticRenderFns }